var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPackageIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15.957,
    viewBox: "0 0 14 15.957",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.33 3.83L6.968 0l2.458 1.447-6.606 3.8z",
    transform: "translate(.021)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.465 2.09l2.851 1.6L6.742 7.5 3.88 5.867z",
    transform: "translate(.248 .133)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.545 4.5v7.457L7.13 15.67V8.234z",
    transform: "translate(.455 .287)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.628 6.606v1.862l-1.2-.617V5.9L0 4.5v7.457l6.415 3.713V8.234z",
    transform: "translate(0 .287)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPackageIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/package-icon.321a71db.svg";
export { ForwardRef as ReactComponent };